import $ from 'jquery';
import Utils from '../utils/Utils.js';

const initMobileFilter = (callback = null, reset = null) => {
    let url = new URL(window.location);
    let button = document.querySelector('.header_filtersMobileButton');
    let render = document.querySelector('.header_filtersMobileButton_render > span');
    let renderDefault = 'Filtrer par';
    let renderSearch = 'modifier';
    let filtersWrap = document.querySelector('.mobileFilters');
    let filtersClose = filtersWrap.querySelector('.mobileFilters_close');
    let filtersFields = filtersWrap.querySelectorAll('.mobileFilters_field');
    let filtersValidate = filtersWrap.querySelector('.mobileFilters_action');
    if (button) {
        button.addEventListener('click', (e) => {
            filtersWrap.classList.add('active');
        });

        filtersClose.addEventListener('click', (e) => {
            filtersWrap.classList.remove('active');
        });

        filtersValidate.addEventListener('click', (e) => {
            filtersWrap.classList.remove('active');
            url.searchParams.delete('pg');
            Utils.updateUrl(url.href);

            if (reset) {
                reset();
            }

            if (callback) {
                callback();
            }
        });

        if (url.search == '' || url.searchParams.has('search')) {
            render.innerHTML = renderDefault;
        } else {
            render.innerHTML = renderSearch;
        }


        filtersFields.forEach((fieldElt) => {
            let field = fieldElt.getAttribute('data-field');
            let isMultiple = fieldElt.hasAttribute('data-field-multiple');
            let items = fieldElt.querySelectorAll('.mobileFilters_field_list a');

            items.forEach((link) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    let values = [];
                    let value = link.getAttribute('data-value');

                    if (isMultiple) {
                        if (link.classList.contains('active')) {
                            link.classList.remove('active');
                        } else {
                            link.classList.add('active');
                        }
                    } else {
                        if (fieldElt.querySelector('.mobileFilters_field_list .active')) {
                            fieldElt.querySelector('.mobileFilters_field_list .active').classList.remove('active');
                        }
                        link.classList.add('active');
                    }

                    if (fieldElt.querySelectorAll('.mobileFilters_field_list .active')) {
                        fieldElt.querySelectorAll('.mobileFilters_field_list .active').forEach((l) => {
                            values.push(l.getAttribute('data-value'));
                        })
                    }

                    url.searchParams.delete('pg');

                    if (value == 'all') {
                        url.searchParams.delete(field);
                        if (fieldElt.querySelectorAll('.mobileFilters_field_list .active')) {
                            fieldElt.querySelectorAll('.mobileFilters_field_list .active').forEach((l) => {
                                l.classList.remove('active');
                            })
                        }
                        link.classList.add('active');
                    } else {
                        fieldElt.querySelector('[data-value="all"]').classList.remove('active');
                        url.searchParams.set(field, values.join(','));
                    }

                    if (url.search == '') {
                        render.innerHTML = renderDefault;
                    } else {
                        render.innerHTML = renderSearch;
                    }

                    Utils.updateUrl(url.href);
                });
            })
        });

    }

};

/**
 * Accordéon filtres mobile — annuaire partenaires (Figma 1977:614 / 1977:1488).
 * Pas de drawer modal : toggle Afficher / Masquer sur le panneau in-flow.
 * Libellés : data-label-show / data-label-hide (PHP), pas de strings UI dans le JS.
 */
const initPartnersMobileFilter = (root) => {
    if (!root) {
        return null;
    }

    const toggle = root.querySelector('[data-partners-mobile-filters-toggle]');
    const labelEl = root.querySelector('[data-partners-filters-toggle-label]') || toggle;
    if (!toggle) {
        return null;
    }

    const labelShow = toggle.getAttribute('data-label-show') || labelEl?.textContent?.trim() || '';
    const labelHide = toggle.getAttribute('data-label-hide') || labelShow;

    const setOpen = (open) => {
        root.classList.toggle('is-filters-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (labelEl) {
            labelEl.textContent = open ? labelHide : labelShow;
        }
    };

    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        setOpen(!root.classList.contains('is-filters-open'));
    });

    setOpen(false);

    return {
        isOpen: () => root.classList.contains('is-filters-open'),
        open: () => setOpen(true),
        close: () => setOpen(false),
    };
};

export { initMobileFilter, initPartnersMobileFilter };
